import React from 'react';
import { css } from '@emotion/css';
import c from 'classnames';

import useToggle from '@lyearn/core/hooks/useToggle';
import { ArrowRightFillLegacy } from '@lyearn/icons';
import { useNodeStatesContext, useReactNodeView } from '@lyearn/lygo-core';
import { Box, Stack } from '@lyearn/ui';

const toggleContainerStyles = css`
  .ProseMirror__contentDOM {
    flex: 1;
  }
`;

const ToggleListItem: React.FC<React.PropsWithChildren> = (props) => {
  const { node } = useReactNodeView();
  const [expanded, { toggle }] = useToggle(false);
  const { setNodeState } = useNodeStatesContext();

  const nodeId = node?.attrs.id;

  const handleToggle = React.useCallback(() => {
    if (!nodeId) return;
    setNodeState?.(nodeId, { expanded: !expanded });
    toggle();
  }, [expanded, nodeId, setNodeState, toggle]);

  return (
    <Stack key={nodeId} className={c('mt-16 w-full', toggleContainerStyles)}>
      <Box
        className="cursor-pointer pt-4 me-12"
        contentEditable={false}
        role="button"
        onClick={handleToggle}>
        <ArrowRightFillLegacy
          className={c(
            { 'rotate-90 transform': expanded },
            'transition-all duration-300 ease-out rtl:rotate-180',
            'rounded-4 hover:bg-interactive-secondary',
          )}
          height={20}
          width={20}
        />
      </Box>
      {props.children}
    </Stack>
  );
};

export default ToggleListItem;
